import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "agentReports",
  initialState: {
    summary: "",
    details: "",
    selectedRow: [],
  },

  reducers: {
    setSummaryList: (state, action) => {
      state.summary = action.payload.summary;
      console.log(state.summary)
    },
    setDetailsList: (state, action) => {
      state.details = action.payload.details;
    },
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload.selectedRow
    }
  },
});

export const setSummaryList = userSlice.actions.setSummaryList;
export const setDetailsList = userSlice.actions.setDetailsList;
export const setSelectedRow = userSlice.actions.setSelectedRow;
export default userSlice.reducer;
